import { useTranslation } from "react-i18next";
import TabsComponent from "../../../../components/tabs/TabsComponent";
import SanadsInfo from "./SanadsInfo";
import ProfileInfo from "./ProfileInfo";
import Synchronizers from "./SynchronizersPage";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import ChangePasswordPage from "../../../authentication/ChangePassword";

export default function PersonalInfo() {
  const LocalBasePath = "page.tutor.dashboard.personalInfo";
  const { t } = useTranslation("", { keyPrefix: LocalBasePath });
  const [searchParams, setSearchParams] = useSearchParams();
  const tabs = [
    { name: t("info"), cypressSelector: "info", content: <ProfileInfo /> },
    { name: t("sanads"), cypressSelector: "sanads", content: <SanadsInfo /> },
    {
      name: t("synchronize"),
      cypressSelector: "synchronize",
      content: <Synchronizers />,
    },
    {
      name: t("changePassword"),
      cypressSelector: "changePassword",
      content: <ChangePasswordPage />,
    },
  ];

  return (
    <div className="w-full flex flex-col px-8">
      <div>
        <h1 className=" text-2xl font-semibold text-gray-900 pt-6 pb-4">
          {t("myPersonalInfo")}
        </h1>
      </div>
      <TabsComponent defaultTab={+(searchParams.get("tab") ?? 0)} tabs={tabs} />
    </div>
  );
}
